import axios from "../../utils/axios";

export const fetchPosts = async (filter) => {
    let query = []
    if (filter.sort) {
        if (filter.sort === 'newest') {
            query.push("_sort=createdAt&_order=desc")
        }
        else if (filter.sort === 'most_liked') {
            query.push('_sort=likes&_order=desc')
        }
    }
    if (!filter.all) {
        query.push('isSaved_like=true')
    }
    const stringQuery = query.join('&')
    if (stringQuery) {

        const response = await axios.get(`/blogs?${stringQuery}`);
        return response.data
    }
    else {
        const response = await axios.get(`/blogs`);
        return response.data

    }

}